import React from 'react'

import { YTicks as Component } from './YTicks'

const YTicks = props => {
  return <Component {...props} />
}
export default YTicks
